module.exports = __webpack_public_path__ + "media/media/favicon/favicon-32x32-be94fd0c7600190e0aefa99837341366.png";